const mock = {
  flows: [],
  data_sets: [
    {
      id: 1234,
      role: 'admin',
    },
  ],
  data_sources: [
    {
      id: 1234,
      role: 'collaborator',
    },
  ],
  data_sinks: [],
  credentials: [
    {
      id: 34,
      role: 'collaborator',
    },
  ],
  transforms: [],
};

export default function useSharedResourcesInfo(userId) {
  return mock;
  // return useSelector((state: any) => state.acl.sharedResources?.[userId]);
}
